



































































import { Component, Vue } from 'vue-property-decorator';
import MountainBox from '@/components/MountainBox.vue';
import Logo from '@/components/Logo.vue';
import { IRules, sValidation } from '@/components/UI/Form/ValidationModule';
import { validateMin, validateRequired } from '@/components/UI/Form/Validations';
import Locale from '@/utils/locale';

const validatePassword: sValidation = data => {
  if (!data.formElements.password) return true;

  return data.dataValue === data.formElements.password.dataValue;
};

@Component({
  components: {
    MountainBox,
    Logo,
  },
})
export default class ConfirmPasswordReset extends Vue {
  private mounted() {
    this.confirmPasswordReset();
  }

   private loading = false;

  private newPassword = null as string | null;
  private passwordConfirmation = null as string | null;
  private validForm = true;

  private errorMessage = null as string | null;
  private tokenExpired = false;
  private successfulTokenVerification = false;
  private serverHost: string | undefined = process.env.VUE_APP_API_HTTP;

  private rules: IRules = {
    password: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.password') }),
      },
      {
        validation: validateMin(6),
        message: i18n => i18n.t('Error.minLength', { length: 6 }),
      },
    ],
    confirmPassword: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Account.confirmPassword') }),
      },
      {
        validation: validatePassword,
        message: i18n => i18n.t('Account.passwordNotSame'),
      },
    ],
  };

  private async confirmPasswordReset() {
    const passwordResetToken = this.$route.query.token;

    if (!passwordResetToken) {
      this.errorMessage = this.$t('Account.passwordResetTokenMissing') as string;
      return;
    }

    try {
      const response = await fetch(`${this.serverHost}/accounts/confirm_password_reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          password_reset_token: passwordResetToken,
        }),
      });

      if (response.status === 200) {
        this.successfulTokenVerification = true;
      } else {
        const payload = await response.json();
        if (payload.error === 'token_expired') {
          this.tokenExpired = true;
        } else {
          this.errorMessage = this.$t('Error.somethingWentWrong') as string;
        }
      }
    } catch (error) {
      this.errorMessage = this.$t('Error.somethingWentWrong') as string;
    }
  }

  private async resetPassword() {
    const passwordResetToken = this.$route.query.token;

    if (!passwordResetToken) {
      this.errorMessage = this.$t('Account.passwordResetTokenMissing') as string;
      return;
    }

    this.loading = true;

    try {
      const response = await fetch(`${this.serverHost}/accounts/reset_password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          password_reset_token: passwordResetToken,
          new_password: this.newPassword,
          password_confirmation: this.passwordConfirmation,
          locale: Locale.get(),
        }),
      });

      this.loading = false;

      if (response.status === 200) {
        this.$sMessage.success(this.$t('Account.successfullyResetPassword'), {duration: 0});
        this.$router.replace({ name: 'Login'});
      } else {
        const payload = await response.json();
        if (payload.errors) {
          this.errorMessage = payload.errors.join(', ');
        } else {
          this.errorMessage = this.$t('Error.somethingWentWrong') as string;
        }
      }
    } catch (error) {
      this.loading = false;
      this.errorMessage = this.$t('Error.somethingWentWrong') as string;
    }
  }
}
